import {BaseApiModel} from "./base-api-model";
import {BaseApiRequestModel} from "./base-api-request-model";

export class BaseApiResponseModel extends BaseApiModel {
  requestedUpdateId: number;
  lastUpdateId: Number;
  ttl: Number;
  delta: Promise<>;
  request: BaseApiRequestModel;
  forceUpdateOnBackground: Boolean;

  constructor(model: BaseApiResponseModel, request: BaseApiRequestModel) {
    super();

    this.requestedUpdateId = model?.requestedUpdateId;
    this.lastUpdateId = model?.lastUpdateId;
    this.ttl = model?.ttl;
    this.request = request;
    this.forceUpdateOnBackground = false;
    Object.assign(this, model);
  }

  get hasUpdate(){
    return this.isInitialRequest || this.requestedUpdateId !== this.lastUpdateId;
  }

  get isDelta(){
    return !!this.requestedUpdateId && this.requestedUpdateId !== -1;
  }

  get isInitialRequest(){
    return !this.requestedUpdateId || this.requestedUpdateId === -1;
  }

  get shouldCreateNextDelta(){
    return !!this.lastUpdateId && this.ttl > 0;
  }
}
